import React from "react";

function DataTable(props) {

    const [metVisible, setMetVisible] = React.useState(false)
    const [specVisible, setSpecVisible] = React.useState(false)

    const handleMet = () => {
        setMetVisible(!metVisible);
    }

    const handleSpec = () => {
        setSpecVisible(!specVisible);
    }

    return(
        <div key={Math.floor(Math.random() * 10000000)} className="mt-3 mb-10 mobile-mx-0">
            <h3 className="font-bold">Buoy ID: {props.buoyId}</h3>

            <button className={`${metVisible ? "mt-3 btn-primary mx-3" : "mt-3 btn-secondary mx-3"}`} onClick={handleMet}>Meteorological Data</button>
            <button className={`${specVisible ? "mt-3 btn-primary mx-3" : "mt-3 btn-secondary mx-3"}`} onClick={handleSpec}>Spectral Data</button>

            <div className={metVisible ? "" : "hidden"}>
                <h3 className="mt-3">Meteorological Data</h3>
                <div className="mobile-scroll mb-3">
                    <table className="mt-2 ">
                        <thead>
                            <tr>
                                {props.meteorological.headers.map(header => <th key={header}>{header}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {props.meteorological.data.map((dataSet) => {
                                return (
                                    <tr key={Math.floor(Math.random() * 10000000)}>
                                        {dataSet.map((item) => <td key={`${Math.floor(Math.random() * 10000000)}`}>{item}</td>)}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className={specVisible ? "" : "hidden"}>
                <h3 className="mt-3">Spectral Data</h3>
                <div className="mobile-scroll">
                    <table className="mt-2">
                        <thead>
                            <tr>
                                {props.spectral.headers.map(header => <th key={header}>{header}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {props.spectral.data.map((dataSet) => {
                                return (
                                    <tr key={Math.floor(Math.random() * 10000000)}>
                                        {dataSet.map((item) => <td key={`${Math.floor(Math.random() * 10000000)}`}>{item}</td>)}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            
        </div>)
}

export default DataTable;